import {
  DropdownSize,
  Option,
} from 'components/core/DropdownWithSearch/DropdownWithSearch.types';

const BORDER_COLOR = 'rgba(242,242,242,1)';
const GREY_BG = 'rgba(242,242,242,1)';
const WHITE_BG = '#ffffff';

export interface SizeConfig {
  fontSize: string;
  controlPadding: string;
  valueContainerPadding: string;
  optionPadding: string;
  optionPaddingCustomLabel: string;
  indicatorSize: string;
  minHeight: string;
  menuMaxHeight: number;
}

export const sizeConfigMap: Record<DropdownSize, SizeConfig> = {
  sm: {
    fontSize: '13px',
    controlPadding: '0px',
    valueContainerPadding: '2px 6px',
    optionPadding: '6px 8px',
    optionPaddingCustomLabel: '8px 10px',
    indicatorSize: '20px',
    minHeight: '32px',
    menuMaxHeight: 220,
  },
  md: {
    fontSize: '14px',
    controlPadding: '0px',
    valueContainerPadding: '2px 8px',
    optionPadding: '10px',
    optionPaddingCustomLabel: '12px 10px',
    indicatorSize: '24px',
    minHeight: '38px',
    menuMaxHeight: 300,
  },
  lg: {
    fontSize: '16px',
    controlPadding: '4px 0px',
    valueContainerPadding: '4px 12px',
    optionPadding: '12px 14px',
    optionPaddingCustomLabel: '14px 14px',
    indicatorSize: '28px',
    minHeight: '46px',
    menuMaxHeight: 380,
  },
};

/**
 * Return background color for the react-select control depending on the
 * provided `background` prop. Defaults to GREY_BG for unknown/undefined.
 */
export const getControlBackground = (background?: 'white' | 'grey') => {
  if (background === 'white') return WHITE_BG;
  if (background === 'grey') return GREY_BG;

  return GREY_BG;
};

/**
 * Return a small set of style-related properties for the react-select
 * control. Centralising this logic makes it straightforward to extend in the
 * future (e.g. focus/invalid styles, theme overrides, etc.).
 */
export const getControlStyles = (background?: 'white' | 'grey') => {
  const backgroundColor = getControlBackground(background);

  // When the control uses a white background we want a 1px subtle border to
  // visually separate it from surrounding content. For other backgrounds we
  // intentionally remove the border.
  const border = background === 'white' ? `1px solid ${BORDER_COLOR}` : '0';

  return {
    background: backgroundColor,
    border,
  } as const;
};

/**
 * Return the option whose `value` matches the provided string, or `null` if
 * the input is falsy or no match is found.
 */
export const getOptionByValue = (
  options: Option[],
  value?: string
): Option | null => {
  if (!value) return null;
  const match = options.find(opt => opt.value === value);
  return match ?? null;
};
